import { useMutation } from '@tanstack/react-query';

import { CreateEvent } from '@event/types';

const useEventMutation = () =>
  useMutation({
    mutationFn: (event: CreateEvent) => createEvent(event),
  });

const createEvent = async (event: CreateEvent): Promise<{ slug: string }> => {
  const response = await fetch('/api/event/create', {
    method: 'POST',
    body: JSON.stringify({ ...event }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText);
  }

  return response.json();
};

export default useEventMutation;
